// src/pages/accounting/general/GeneralSalesList.jsx
import React, { useState, useEffect, useRef } from "react";
import styles from "./GeneralSalesList.module.css";
import api from "../../../api";

// ✅ 수정 모달 컴포넌트
function EditModal({ item, onClose, onSaved }) {
  const [form, setForm] = useState({
    deposit_date: item.deposit_date || "",
    bimok: item.bimok || "",
    semok: item.semok || "",
    vendor_name: item.vendor_name || item.customer_name || "",
    doc_type: item.doc_type || "",
    pay_type: item.pay_type || "",
    description: item.description || "",
    supply_amount: item.supply_amount ?? "",
    vat_amount: item.vat_amount ?? "",
    fee_amount: item.fee_amount ?? "",
    total_amount: item.total_amount ?? "",
    bank_account_name: item.bank_account_name || item.bank_account || "",
    deposit_method: item.deposit_method || "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // 공급가액 변경 시 집행액 자동 계산
  const handleAmountChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...form, [name]: value };

    const supply = parseFloat(updated.supply_amount) || 0;
    const vat = parseFloat(updated.vat_amount) || 0;
    const fee = parseFloat(updated.fee_amount) || 0;
    updated.total_amount = (supply + vat - fee).toString();

    setForm(updated);
  };

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      await api.patch(`general-sales/${item.id}/`, form);
      onSaved();
    } catch (err) {
      console.error("수정 실패:", err);
      setError("저장에 실패했습니다. 다시 시도해주세요.");
    } finally {
      setSaving(false);
    }
  };

  // ESC로 닫기
  useEffect(() => {
    const handleEsc = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const fields = [
    { label: "집행일자",   name: "deposit_date",       type: "date"   },
    { label: "비목",       name: "bimok",              type: "text"   },
    { label: "세목",       name: "semok",              type: "text"   },
    { label: "거래처",     name: "vendor_name",        type: "text"   },
    { label: "증빙유형",   name: "doc_type",           type: "text"   },
    { label: "유형",       name: "pay_type",           type: "text"   },
    { label: "상세내역",   name: "description",        type: "text"   },
    { label: "공급가액",   name: "supply_amount",      type: "number", onChange: handleAmountChange },
    { label: "부가세",     name: "vat_amount",         type: "number", onChange: handleAmountChange },
    { label: "수수료",     name: "fee_amount",         type: "number", onChange: handleAmountChange },
    { label: "집행액",     name: "total_amount",       type: "number", readOnly: true },
    { label: "입금통장",   name: "bank_account_name",  type: "text"   },
    { label: "비고",       name: "deposit_method",     type: "text"   },
  ];

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <div style={modalHeader}>
          <h3 style={{ margin: 0, fontSize: "15px" }}>매출자료 수정</h3>
          <button onClick={onClose} style={closeBtn}>✕</button>
        </div>

        <div style={modalBody}>
          {fields.map(({ label, name, type, readOnly, onChange: fieldOnChange }) => (
            <div key={name} style={fieldRow}>
              <label style={fieldLabel}>{label}</label>
              <input
                type={type}
                name={name}
                value={form[name]}
                onChange={fieldOnChange || handleChange}
                readOnly={readOnly}
                style={{
                  ...fieldInput,
                  background: readOnly ? "#f0f0f0" : "#fff",
                  color: readOnly ? "#888" : "#111",
                  textAlign: type === "number" ? "right" : "left",
                }}
              />
            </div>
          ))}
        </div>

        {error && <p style={{ color: "red", fontSize: "13px", padding: "0 20px" }}>{error}</p>}

        <div style={modalFooter}>
          <button onClick={onClose} style={btnSecondary}>취소</button>
          <button onClick={handleSave} disabled={saving} style={btnPrimary}>
            {saving ? "저장 중..." : "저장"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── 인라인 스타일 (모달) ──────────────────────────────────────────────────────
const overlay = {
  position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
  display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
};
const modal = {
  background: "#fff", borderRadius: "10px", width: "480px", maxWidth: "95vw",
  maxHeight: "90vh", display: "flex", flexDirection: "column",
  boxShadow: "0 8px 32px rgba(0,0,0,0.22)",
};
const modalHeader = {
  display: "flex", alignItems: "center", justifyContent: "space-between",
  padding: "16px 20px", borderBottom: "1px solid #e5e7eb",
};
const closeBtn = {
  background: "none", border: "none", fontSize: "18px",
  cursor: "pointer", color: "#6b7280", lineHeight: 1,
};
const modalBody = {
  padding: "16px 20px", overflowY: "auto", flex: 1,
  display: "flex", flexDirection: "column", gap: "10px",
};
const modalFooter = {
  display: "flex", justifyContent: "flex-end", gap: "8px",
  padding: "14px 20px", borderTop: "1px solid #e5e7eb",
};
const fieldRow = { display: "flex", alignItems: "center", gap: "10px" };
const fieldLabel = {
  width: "80px", flexShrink: 0, fontSize: "13px",
  color: "#374151", fontWeight: 500, textAlign: "right",
};
const fieldInput = {
  flex: 1, padding: "6px 10px", fontSize: "13px",
  border: "1px solid #d1d5db", borderRadius: "5px", outline: "none",
};
const btnPrimary = {
  padding: "7px 20px", background: "#2563eb", color: "#fff",
  border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "13px",
  fontWeight: 600,
};
const btnSecondary = {
  padding: "7px 20px", background: "#f3f4f6", color: "#374151",
  border: "1px solid #d1d5db", borderRadius: "6px", cursor: "pointer", fontSize: "13px",
};
// ─────────────────────────────────────────────────────────────────────────────

export default function GeneralSalesList() {

  // ✅ 페이지 타이틀
  useEffect(() => {
    document.title = "(일반) 매출자료 조회";
  }, []); // eslint-disable-line

  // ✅ 사업분야 옵션
  const businessOptions = [
    { label: "경영팀",           code: 1 },
    { label: "용역사업",         code: 2 },
    { label: "CAFE_INN 가산점",  code: 3 },
    { label: "CAFE_INN 독산점",  code: 4 },
    { label: "CAFE_INN 금나래점",code: 5 },
    { label: "환경/소독",        code: 6 },
    { label: "환경/종합",        code: 7 },
  ];

  // ✅ 조회 조건 상태
  const [year, setYear]                   = useState(new Date().getFullYear());
  const [fromDate, setFromDate]           = useState(`${year}-01-01`);
  const [toDate, setToDate]               = useState(`${year}-12-31`);
  const [selectedBusinesses, setSelectedBusinesses] = useState([]);
  const [inputBusinessCode, setInputBusinessCode]   = useState("");
  const businessInputRef = useRef(null);

  // ✅ 데이터 상태
  const [salesList, setSalesList] = useState([]);
  const [loading, setLoading]     = useState(false);

  // ✅ 수정/삭제 상태
  const [editingItem, setEditingItem]   = useState(null); // 수정 모달 대상
  const [deletingId, setDeletingId]     = useState(null); // 삭제 중인 id

  // ✅ 연도 변경 시 기간 자동 업데이트
  useEffect(() => {
    setFromDate(`${year}-01-01`);
    setToDate(`${year}-12-31`);
  }, [year]);

  // ✅ 페이지 로드 시 사업분야 입력창에 포커스
  useEffect(() => {
    businessInputRef.current?.focus();
  }, []);

  // ✅ 날짜 변경 시 자동 재조회
  useEffect(() => {
    if (selectedBusinesses.length > 0) {
      fetchSalesData(selectedBusinesses[0], fromDate, toDate);
    }
  }, [fromDate, toDate]); // eslint-disable-line

  // ✅ 숫자 포맷 (천단위 콤마)
  const formatNumberWithComma = (value) => {
    if (!value) return "0";
    return Number(value).toLocaleString();
  };

  // ✅ 사업분야 체크박스 토글 (단일 선택)
  const handleBusinessToggle = async (optionLabel) => {
    if (selectedBusinesses.includes(optionLabel)) {
      setSelectedBusinesses([]);
      setSalesList([]);
    } else {
      setSelectedBusinesses([optionLabel]);
      await fetchSalesData(optionLabel, fromDate, toDate);
    }
  };

  // ✅ 숫자 입력 → 사업 자동 선택
  const handleBusinessKey = async (e) => {
    if (e.key === "Enter" || e.key === "Tab") {
      e.preventDefault();
      const num = parseInt(inputBusinessCode, 10);
      const found = businessOptions.find((b) => b.code === num);
      if (found) {
        setSelectedBusinesses([found.label]);
        await fetchSalesData(found.label, fromDate, toDate);
      } else {
        alert("해당 번호의 사업구분이 없습니다.");
      }
      setInputBusinessCode("");
    }
  };

  // ✅ 조회 버튼 클릭
  const handleSearch = async () => {
    if (selectedBusinesses.length === 0) {
      alert("사업분야를 선택해주세요.");
      return;
    }
    await fetchSalesData(selectedBusinesses[0], fromDate, toDate);
  };

  // ✅ 매출 데이터 조회
  const fetchSalesData = async (businessLabel, startDate, endDate) => {
    try {
      setLoading(true);
      const params = {
        business_types: businessLabel,
        draft_date_after: startDate,
        draft_date_before: endDate,
        ordering: "-draft_date",
      };
      const res  = await api.get("general-sales/", { params });
      const data = Array.isArray(res.data) ? res.data : res.data.results || [];
      setSalesList(data);
    } catch (err) {
      console.error("❌ 매출 데이터 조회 실패:", err);
      alert("❌ 데이터를 불러오지 못했습니다.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ 삭제 핸들러
  const handleDelete = async (id) => {
    const confirmed = window.confirm("이 매출 데이터를 삭제하시겠습니까?\n삭제 후 복구할 수 없습니다.");
    if (!confirmed) return;

    setDeletingId(id);
    try {
      await api.delete(`general-sales/${id}/`);
      setSalesList((prev) => prev.filter((item) => item.id !== id));
    } catch (err) {
      console.error("❌ 삭제 실패:", err);
      alert("❌ 삭제에 실패했습니다. 다시 시도해주세요.");
    } finally {
      setDeletingId(null);
    }
  };

  // ✅ 수정 완료 후 목록 갱신
  const handleEditSaved = async () => {
    setEditingItem(null);
    if (selectedBusinesses.length > 0) {
      await fetchSalesData(selectedBusinesses[0], fromDate, toDate);
    }
  };

  return (
    <div className={styles.mainLayout}>
      {/* ── 수정 모달 ── */}
      {editingItem && (
        <EditModal
          item={editingItem}
          onClose={() => setEditingItem(null)}
          onSaved={handleEditSaved}
        />
      )}

      {/* 1️⃣ 왼쪽: 조회조건 */}
      <div className={styles.filterArea}>
        <h3>조회조건</h3>

        <div className={styles.filterGroup}>
          <label>연도 선택</label>
          <input
            type="number"
            value={year}
            onChange={(e) => setYear(e.target.value)}
          />
        </div>

        <div className={styles.filterGroup}>
          <label>기간 선택</label>
          <div className={styles.dateColumn}>
            <div>
              <span>시작일자</span>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div>
              <span>종료일자</span>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className={styles.filterGroup}>
          <label>사업 구분</label>
          <input
            ref={businessInputRef}
            type="text"
            value={inputBusinessCode}
            onChange={(e) => setInputBusinessCode(e.target.value)}
            onKeyDown={handleBusinessKey}
            placeholder="번호 입력 후 Enter"
          />
          <div className={styles.businessGroup}>
            {businessOptions.map((opt) => (
              <label key={opt.code} className={styles.businessLabel}>
                <input
                  type="checkbox"
                  checked={selectedBusinesses.includes(opt.label)}
                  onChange={() => handleBusinessToggle(opt.label)}
                  className={styles.businessCheckbox}
                />
                {opt.label} ({opt.code})
              </label>
            ))}
          </div>
        </div>

        <button
          type="button"
          onClick={handleSearch}
          className={styles.searchButton}
        >
          조회하기
        </button>
      </div>

      {/* 2️⃣ 오른쪽: 매출 데이터 테이블 */}
      <div className={styles.contentArea}>
        <div className={styles.header}>
          <h3>(일반) 매출자료 목록</h3>
          <p className={styles.count}>
            총 <strong>{salesList.length}</strong>건
          </p>
        </div>

        {selectedBusinesses.length === 0 && (
          <p className={styles.emptyMessage}>사업분야를 선택하고 조회 버튼을 눌러주세요</p>
        )}
        {loading && (
          <p className={styles.loadingMessage}>데이터를 불러오는 중...</p>
        )}
        {!loading && selectedBusinesses.length > 0 && salesList.length === 0 && (
          <p className={styles.emptyMessage}>조회된 데이터가 없습니다</p>
        )}

        {!loading && salesList.length > 0 && (
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>집행일자</th>
                  <th>비목</th>
                  <th>세목</th>
                  <th>거래처</th>
                  <th>증빙유형</th>
                  <th>유형</th>
                  <th>상세내역</th>
                  <th>공급가액</th>
                  <th>부가세</th>
                  <th>수수료</th>
                  <th>집행액</th>
                  <th>입금통장</th>
                  <th>비고</th>
                  <th style={{ minWidth: "88px" }}>관리</th>  {/* ✅ 추가 */}
                </tr>
              </thead>

              <tbody>
                {salesList.map((item) => (
                  <tr key={item.id}>
                    <td>{item.deposit_date || "-"}</td>
                    <td>{item.bimok || "-"}</td>
                    <td>{item.semok || "-"}</td>
                    <td>{item.vendor_name || item.customer_name || "-"}</td>
                    <td>{item.doc_type || "-"}</td>
                    <td>{item.pay_type || "-"}</td>
                    <td>{item.description || "-"}</td>
                    <td className={styles.numberCell}>{formatNumberWithComma(item.supply_amount)}</td>
                    <td className={styles.numberCell}>{formatNumberWithComma(item.vat_amount)}</td>
                    <td className={styles.numberCell}>{formatNumberWithComma(item.fee_amount)}</td>
                    <td className={styles.numberCell}>{formatNumberWithComma(item.total_amount)}</td>
                    <td>{item.bank_account_name || item.bank_account || "-"}</td>
                    <td>{item.deposit_method || "-"}</td>

                    {/* ✅ 수정/삭제 버튼 */}
                    <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                      <button
                        onClick={() => setEditingItem(item)}
                        style={{
                          padding: "3px 10px",
                          marginRight: "4px",
                          fontSize: "12px",
                          background: "#2563eb",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        수정
                      </button>
                      <button
                        onClick={() => handleDelete(item.id)}
                        disabled={deletingId === item.id}
                        style={{
                          padding: "3px 10px",
                          fontSize: "12px",
                          background: deletingId === item.id ? "#fca5a5" : "#ef4444",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                          cursor: deletingId === item.id ? "not-allowed" : "pointer",
                        }}
                      >
                        {deletingId === item.id ? "삭제중" : "삭제"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}